import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NServices, ServiceClient, UserProfile, UserRoleTypes} from "src/app/web-api-client";
import { ConfirmModalComponent } from "../../../modals/confirm-modal/confirm-modal.component";
import { SuccessModalComponent } from "../../../modals/success-modal/success-modal.component";
import { UnSuccessModalComponent } from "../../../modals/failed-modal/failed-modal.component"; ;
import { ServiceCreationComponent } from "./service-creation/service-creation.component";
import { ServiceEditComponent } from "./service-edit/service-edit.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateHelper } from "src/app/shared/helpers/date.helper";
import { Organization } from "../../../models/organisation.model";
import { WtStorageService } from "../../../wt-storage.service";


@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class ServiceComponent implements OnInit {

  public isLoaded: boolean = false;
  selectedService: NServices;
  public services: NServices[];
  public searchQuery: string = '';
  public filteredServices: NServices[] = [];
  public currentUser: UserProfile;

  constructor(private readonly changeDetectionRef:ChangeDetectorRef,private readonly localStore:WtStorageService, private readonly modalService: NgbModal,public client:ServiceClient){

  }

  ngOnInit(): void {

    this.LoadData();
    this.currentUser = this.localStore.getuser();

  }


  private LoadData() {
        this.client.getList().subscribe((allServices: NServices[]) => {
            this.isLoaded = false;
          this.services = allServices;
          this.filteredServices = allServices;
            this.isLoaded = true;
            this.changeDetectionRef.detectChanges();
        });
    }

  public filterServices() {
    if (this.searchQuery) {
      this.filteredServices = this.services.filter(service =>
        service.serviceName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.uri.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.yri.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase())  
      );
    } else {
      this.filteredServices = this.services;
    }
  }

 public onSelected(service:NServices){
   if (this.isSelected(service)){
    this.selectedService = null;
  }
  else{

     this.selectedService = service;
  }
 }

 public isSelected(service:NServices):boolean{
   return this.selectedService == service;
 }

public onCreation():void{
  let modalRef =  this.modalService.open(ServiceCreationComponent, {});
  modalRef.componentInstance.onClose.subscribe(r => {
    this.LoadData();
  })
}


public onDelete(): void {


    let modalRef = this.modalService.open(ConfirmModalComponent);

    modalRef.componentInstance.onClose.subscribe(result => {
      if (result === true) {

        this.client.remove(this.selectedService.idService).subscribe(r => {
          this.modalService.open(SuccessModalComponent);
        })
      }
      else {
        this.modalService.open(UnSuccessModalComponent);
      }
    });


  }

  public canEdit(): boolean {

    if (!this.selectedService)
      return false;

    let isGlobalAdmin = this.currentUser.userRole == UserRoleTypes.Global_Admin;
    let isUserInSameORg = this.currentUser.organizationId == this.selectedService.organizationId;
    return this.currentUser && this.selectedService && (isGlobalAdmin || isUserInSameORg);
  }
  public onEdit(): void {

    let isGlobalAdmin = this.currentUser.userRole == UserRoleTypes.Global_Admin;
    let isUserInSameORg = this.currentUser.organizationId == this.selectedService.organizationId;

    if (this.currentUser && this.selectedService && (isGlobalAdmin || isUserInSameORg)) {

      let modalRef = this.modalService.open(ServiceEditComponent, { size: 'xl', centered: true, backdrop: 'static' });
      modalRef.componentInstance.editService = this.selectedService;
      modalRef.componentInstance.onClose.subscribe(r => {
        this.LoadData();
      })

    }


    }

    public getDate(item:Date):string{
      return DateHelper.GetFormattedDate(item);
  }


  public canSee(): boolean {

    return this.currentUser.userRole != UserRoleTypes.User
  }
}
